import React, {useState, useEffect, Suspense, lazy} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import StackProgress from "./skillProgress/skillProgress";
import Footer from "../components/footer/Footer";
import Top from "./topbutton/Top";
import {StyleProvider} from "../contexts/StyleContext";
import "./Main.scss";

const Education = lazy(() => import("./education/Education"));
const WorkExperience = lazy(() => import("./workExperience/WorkExperience"));
const Achievement = lazy(() => import("./achievement/Achievement"));
const Profile = lazy(() => import("./profile/Profile"));

export default function Main() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("isDark") === null) {
      const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
      localStorage.setItem("isDark", darkPref.matches);
    }
    setIsDark(JSON.parse(localStorage.getItem("isDark")));
  }, []);

  function changeTheme() {
    setIsDark(prev => {
      localStorage.setItem("isDark", !prev);
      return !prev;
    });
  }

  return (
    <div className={isDark ? "dark-mode" : null}>
      <StyleProvider value={{isDark, changeTheme}}>
        <Header />
        <main id="main-content">
          <Greeting />
          <Skills />
          <StackProgress />
          <Suspense fallback={null}>
            <Education />
            <WorkExperience />
            <Achievement />
            <Profile />
          </Suspense>
        </main>
        <Footer />
        <Top />
      </StyleProvider>
    </div>
  );
}
